<template>
<el-date-picker
    ref="main"
    class="l-time"
    :format="myformat"
    :valueFormat="myformat"
    :placeholder="placeholder"
    :startPlaceholder="startPlaceholder"
    :endPlaceholder="endPlaceholder"
    :readonly="readonly"
    :disabled="disabled"
    :editable="editable"
    :clearable="clearable"
    :size="size"
    :type="dateType"
    :align="align"
    :rangeSeparator="rangeSeparator"
    :defaultValue="defaultValue"
    :unlink-panels="unlinkPanels"


    v-model="value2"
  >
</el-date-picker>

</template>
<script>
import { validatenull } from '@util/validate';
export default {
  name:'l-date',
  props: {
    value:{},
    placeholder:String,
    startPlaceholder:String,
    endPlaceholder:String,
    readonly:Boolean,
    disabled:Boolean,
    editable:Boolean,
    
    clearable:{
        type:Boolean,
        default:true
    },
    size:String,
    dateType:{
        type:String,
        default:'date'
    },
    align:String,
    rangeSeparator:{
        type:String,
        default:'-'
    },
    defaultValue:Date,
    defaultItem:String,
    

    format:String,
   
    selectableRange:[String,Array],

    unlinkPanels:{
        type:Boolean,
        default:true
    },
   
    
  },
  created(){
    if(this.defaultItem == "currentYear"){
        let d = new Date
        let year1 = d.getFullYear();
        let date1 = new Date(year1, 0, 1)
        let date2 = new Date(year1, 12, 0) //月末
        this.value2 = [this.$formatDate(date1,'yyyy-MM-dd'), this.$formatDate(date2,'yyyy-MM-dd')]
    }
    if(this.defaultItem == "currentMonth"){
        let d = new Date
        let year1 = d.getFullYear(),month1 = d.getMonth();
        let date1 = new Date(year1, month1, 1)
        let date2 = new Date(year1, month1+1, 0) //月末
        this.value2 = [this.$formatDate(date1,'yyyy-MM-dd'), this.$formatDate(date2,'yyyy-MM-dd')]
    }
    if(this.defaultItem == "currentDay"){
        let d = new Date
        if(this.isRange)
            this.value2 = [this.$formatDate(d,'yyyy-MM-dd'), this.$formatDate(d,'yyyy-MM-dd')]
        else
            this.value2 = d
    }
    if(this.defaultItem == "last7days"){
        let d = new Date
        let date2 = new Date
        date2.setDate(d.getDate()-7)
        this.value2 = [this.$formatDate(date2,'yyyy-MM-dd'), this.$formatDate(d,'yyyy-MM-dd')]
     }
    if(this.defaultItem == "last1month"){
        let d = new Date
        let date2 = new Date
        date2.setMonth(d.getMonth()-1)
        this.value2 = [this.$formatDate(date2,'yyyy-MM-dd'), this.$formatDate(d,'yyyy-MM-dd')]
    }
    if(this.defaultItem == "last3months"){
        let d = new Date
        let date2 = new Date
        date2.setMonth(d.getMonth()-3)
        this.value2 = [this.$formatDate(date2,'yyyy-MM-dd'), this.$formatDate(d,'yyyy-MM-dd')]
    }
    if(this.defaultItem == "lastyear"){
        let d = new Date
        let date2 = new Date
        date2.setFullYear(d.getFullYear()-1)
        this.value2 = [this.$formatDate(date2,'yyyy-MM-dd'), this.$formatDate(d,'yyyy-MM-dd')]
    }
  },
  data () {
      return {
      }
  },
  mounted () {
    
  },
  computed:{
      value2:{
          get(){
              if(this.isRange){
                  if(validatenull(this.value)){
                    return ["",""];
                  }
                  else{
                    return this.value.split(' - ');
                  }
              }
              else{
                  return this.value;
              }
          },
          set(newValue){
                if(this.isRange){
                    if(validatenull(newValue)){
                        this.$emit('input', '');
                    }
                    else{
                        this.$emit('input',`${newValue[0]} ${this.rangeSeparator} ${newValue[1]}`);
                    }
                   
                }
                else{
                    this.$emit('input', newValue);
                }

                this.$emit('change',newValue);
          }
      },
      myformat(){
          let format = ''
          switch(this.dateType){
                case 'datetime':
                    format = 'yyyy-MM-dd HH:mm:ss'
                    break
                case 'datetimerange':
                    format = 'yyyy-MM-dd HH:mm'
                    break
                case 'daterange':
                    format = 'yyyy-MM-dd'
                    break 
                case 'monthrange':
                    format = 'yyyy-MM'
                    break 
          }
          return this.format || format
          
      },
      isRange(){
          return ['datetimerange','daterange','monthrange'].includes(this.dateType)
      }
  },
  methods:{
        formatDate(date, fmt){
            var o = {
                "M+": date.getMonth() + 1, //月份
                "d+": date.getDate(), //日
                "h+": date.getHours(), //小时
                "m+": date.getMinutes(), //分
                "s+": date.getSeconds(), //秒
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                "S": date.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        },
        //设置默认日期
        defaultDate(){
            //获取新的时间(2019.4.12）
            let date = new Date()
            //获取当前时间的年份转为字符串
            let year = date.getFullYear().toString()   //'2019'
            //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
            let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString()  //'04'
            //获取天，判断是否小于10，如果是在字符串前面拼接'0'
            let da = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString()  //'12'
            //字符串拼接，开始时间，结束时间
            let end = year + '-' + month + '-' + da  //当天'2019-04-12'
            let beg = year + '-' + month + '-01'    //当月第一天'2019-04-01'
            this.value2 = [beg,end] //将值设置给插件绑定的数据
        },

  }
}
</script>
